<template>
  <div v-show="showPagination">
    <v-card class="pagination" elevation="0" :outlined="!noBorders">
      <PaginationOrder class="pagination__order" :fetch="fetch" :fetchParams="fetchParams" v-if="requireOrderByFilter" />
      <PaginationSelect class="pagination__paginate" :fetch="fetch" :fetchParams="fetchParams" />
    </v-card>
    <v-progress-linear v-if="isLoading" height="1" indeterminate />
  </div>
</template>

<script>
import PaginationOrder from './PaginationOrder.vue'
import PaginationSelect from './PaginationSelect.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Pagination',

  props: {
    fetch: {
      type: Function,
      required: true,
    },

    fetchParams: {
      type: Array,
      required: false
    },

    noBorders: {
      type: Boolean,
      default: false,
    },

    requireOrderByFilter: {
      default: true
    }
  },

  components: {
    PaginationOrder,
    PaginationSelect,
  },

  computed: {
    ...mapGetters(['totalPages', 'isLoading']),

    showPagination() {
      return this.totalPages > 1
    },
  },
}
</script>
